import { QualificationInterface } from "../interfaces/QualificationInterface";
import { QualificationStandardEnum } from "../enums/QualificationStandardEnum";

export const getTotalPlusCount = (
    qualificationData?: QualificationInterface[],
): number => {
    if (!qualificationData || qualificationData.length === 0) {
        return 0;
    }

    return qualificationData.filter((qualification) =>
        qualification.qualification_standards?.some(
            (standard) => standard.code === QualificationStandardEnum.PLUS,
        ),
    ).length;
};
